"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.variantSizes = exports.variantColors = exports.richTextNodeTypes = exports.listIconProp = exports.linkTargetOptions = exports.linkColourOptions = exports.iconSizeOptions = exports.iconColorOptions = exports.headingSizes = exports.documentProp = exports.documentNodeProp = exports.alignOptions = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var richTextNodeTypes = exports.richTextNodeTypes = ['paragraph', 'heading-1', 'heading-2', 'heading-3', 'heading-4', 'heading-5', 'heading-6', 'ordered-list', 'unordered-list', 'list-item', 'hr', 'blockquote', 'embedded-entry-block', 'embedded-asset-block', 'table', 'table-row', 'table-cell', 'table-header-cell'];
var headingSizes = exports.headingSizes = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'];
var variantSizes = exports.variantSizes = ['micro', 'small', 'medium', 'large', 'eyebrow', 'display1', 'display2', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'];
var variantColors = exports.variantColors = ['default', 'brand', 'brand2', 'brand3', 'dark', 'light', 'positive', 'warning', 'danger', 'black', 'white', 'alternative1', 'alternative2', 'alternative3'];
var alignOptions = exports.alignOptions = ['auto', 'left', 'right', 'center', 'justify'];
var iconSizeOptions = exports.iconSizeOptions = ['small', 'medium', 'large', 'extra large'];
var iconColorOptions = exports.iconColorOptions = ['purpleTelus', 'greyCharcoal', 'greyShuttle', 'redDark', 'amberDark', 'greenAccessible', 'white'];
var linkColourOptions = exports.linkColourOptions = ['default', 'alternative'];
var linkTargetOptions = exports.linkTargetOptions = ['_self', '_blank', '_parent', '_top'];
var documentNodeProp = exports.documentNodeProp = _propTypes.default.shape({
  data: _propTypes.default.object,
  nodeType: _propTypes.default.string,
  content: _propTypes.default.arrayOf(_propTypes.default.shape({
    data: _propTypes.default.object,
    nodeType: _propTypes.default.string,
    content: _propTypes.default.array
  }))
});
var documentProp = exports.documentProp = _propTypes.default.oneOf([documentNodeProp, _propTypes.default.arrayOf(documentNodeProp)]);
var listIconProp = exports.listIconProp = _propTypes.default.shape({
  iconName: _propTypes.default.string,
  iconColor: _propTypes.default.oneOf(iconColorOptions),
  iconSize: _propTypes.default.oneOf(iconSizeOptions)
});